var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.step == 0)?_c('Step_0'):_vm._e(),(_vm.step == 1)?_c('Step_1'):_vm._e(),(_vm.step == 2)?_c('Step_2'):_vm._e(),(_vm.step == 3)?_c('Step_3'):_vm._e(),(_vm.step == 4)?_c('Step_4'):_vm._e(),(_vm.step == 5)?_c('Step_5'):_vm._e(),(_vm.step == 6)?_c('Step_6'):_vm._e(),(_vm.step == 7)?_c('Step_7'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }